import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { cgpAuthentication } from './modules/cgp-authentication';
import { environment } from './environments/environment';
import { setEnv, ENV } from './modules/utility';

if (environment.production) {
    enableProdMode();
}

ENV.subscribe(x => {
    if (x == "") {
        cgpAuthentication.updateMescLoading("MESC is unavailable. Please contact technical support and try again");
        return;
    }else if(x){
        cgpAuthentication.validateToken(() => {
            platformBrowserDynamic()
            .bootstrapModule(AppModule)
            .catch(err => console.error(err));
        });
    }
});

setEnv();
